import { AuthActionCreators, IGet } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

export interface ICoachNotification {
    micrositeRecipientId: number;
    commId: number;
    patientName: string;
    note: string;
    reply: string | null;
    sendDateTime: string;
    replyDateTime: string | null;
    sentByRecipient: boolean;
}

interface IRetVal {
    loading: boolean;
    error: string;
    notifications: ICoachNotification[];
    total: number;
    refresh: () => void;
}

const PAGE_SIZE = 10;

const useCoachNotifications = (contactId: number, page: number = 1): IRetVal => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [notifications, setNotifications] = useState<ICoachNotification[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [refreshKey, setRefreshKey] = useState<number>(0);

    const { dispatch } = useAppHookContext();

    useEffect(() => {
        if (!contactId) {
            return;
        }

        setLoading(true);
        setError('');

        const fetchData = async () => {
            const config: IGet = {
                url: `${__API__}/microsite/coach/notifications?coachContactId=${contactId}&page=${page}&pageSize=${PAGE_SIZE}`
            };

            try {
                const response = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.success) {
                    setNotifications(response.data.results.notifications);
                    setTotal(response.data.results.total);
                } else {
                    setError('Unable to load notifications');
                    setNotifications([]);
                    setTotal(0);
                }
            } catch (err) {
                setNotifications([]);
                setTotal(0);
                setError(err?.message ?? 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [contactId, page, refreshKey]);

    const refresh = () => setRefreshKey(k => k + 1);

    return { loading, error, notifications, total, refresh };
}

export { PAGE_SIZE };
export default useCoachNotifications;
